import { FormElementEnum, ProductConfig } from "./types";
import i18next from "../../config";

const productConfig: ProductConfig = {
    "genericAccount": [
        {
            type: FormElementEnum.Textbox,
            questionId: "genericAccountName",
            label: i18next.t("FormQuestions.accountName"),
            englishLabelText: i18next.t("FormQuestions.accountName", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.accountNamePlaceholder"),
            maxCharLength: 100
        },
        {
            type: FormElementEnum.Date,
            questionId: "genericAccountDate",
            label: i18next.t("FormQuestions.date"),
            englishLabelText: i18next.t("FormQuestions.date", { lng: "en" }),
            defaultDate: new Date()
        },
        {
            type: FormElementEnum.TimeZone,
            questionId: "genericAccountTimeZone",
            label: i18next.t("FormQuestions.timezone"),
            englishLabelText: i18next.t("FormQuestions.timezone", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.timezonePlaceholder"),
        },
        {
            type: FormElementEnum.Time,
            questionId: "genericAccountTime",
            label: i18next.t("FormQuestions.time"),
            englishLabelText: i18next.t("FormQuestions.time", { lng: "en" }),
        }
    ],
    "outlook": [
        {
            type: FormElementEnum.Textbox,
            questionId: "outlookSenderEmail",
            label: i18next.t("FormQuestions.emailAddress"),
            englishLabelText: i18next.t("FormQuestions.emailAddress", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.emailAddressPlaceholder"),
            maxCharLength: 100
        },
        {
            type: FormElementEnum.Date,
            questionId: "outlookEmailDate",
            label: i18next.t("FormQuestions.emailDate"),
            englishLabelText: i18next.t("FormQuestions.emailDate", { lng: "en" }),
            defaultDate: new Date()
        },
        {
            type: FormElementEnum.TimeZone,
            questionId: "outlookEmailTimeZone",
            label: i18next.t("FormQuestions.emailTimezone"),
            englishLabelText: i18next.t("FormQuestions.emailTimezone", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.emailTimezonePlaceholder"),
        },
        {
            type: FormElementEnum.Time,
            questionId: "outlookEmailTime",
            label: i18next.t("FormQuestions.emailTime"),
            englishLabelText: i18next.t("FormQuestions.emailTime", { lng: "en" }),
        }
    ],
    "groupme": [
        {
            type: FormElementEnum.Textbox,
            questionId: "groupMeUsername",
            label: i18next.t("FormQuestions.usernameOfViolator"),
            englishLabelText: i18next.t("FormQuestions.usernameOfViolator", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.usernameOfViolatorPlaceholder"),
            maxCharLength: 100
        },
        {
            type: FormElementEnum.Textbox,
            questionId: "groupMeChatTitle",
            label: i18next.t("FormQuestions.groupChatTitle"),
            englishLabelText: i18next.t("FormQuestions.groupChatTitle", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.groupChatTitlePlaceholder"),
            maxCharLength: 100
        },
        {
            type: FormElementEnum.TextArea,
            questionId: "groupMeMessageText",
            label: i18next.t("FormQuestions.messageText"),
            englishLabelText: i18next.t("FormQuestions.messageText", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.messageTextPlaceholder"),
            maxCharLength: 1000
        },
        {
            type: FormElementEnum.Date,
            questionId: "groupMeMessageDate",
            label: i18next.t("FormQuestions.messageDate"),
            englishLabelText: i18next.t("FormQuestions.messageDate", { lng: "en" }),
            defaultDate: new Date()
        },
        {
            type: FormElementEnum.TimeZone,
            questionId: "groupMeMessageTimeZone",
            label: i18next.t("FormQuestions.messageTimezone"),
            englishLabelText: i18next.t("FormQuestions.messageTimezone", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.timezonePlaceholder"),
        },
        {
            type: FormElementEnum.Time,
            questionId: "groupMeMessageTime",
            label: i18next.t("FormQuestions.messageTime"),
            englishLabelText: i18next.t("FormQuestions.messageTime", { lng: "en" }),
        }
    ],
    "generic": [
        {
            type: FormElementEnum.TextArea,
            questionId: "genericContentOrigin",
            label: i18next.t("FormQuestions.originOfContent"),
            englishLabelText: i18next.t("FormQuestions.originOfContent", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.originOfContentPlaceholder"),
            maxCharLength: 1000
        },
        {
            type: FormElementEnum.Date,
            questionId: "genericContentDate",
            label: i18next.t("FormQuestions.date"),
            englishLabelText: i18next.t("FormQuestions.date", { lng: "en" }),
            defaultDate: new Date()
        },
        {
            type: FormElementEnum.TimeZone,
            questionId: "genericTimeZone",
            label: i18next.t("FormQuestions.timezone"),
            englishLabelText: i18next.t("FormQuestions.timezone", { lng: "en" }),
            placeholder: i18next.t("FormQuestions.timezonePlaceholder"),
        },
        {
            type: FormElementEnum.Time,
            questionId: "genericTime",
            label: i18next.t("FormQuestions.time"),
            englishLabelText: i18next.t("FormQuestions.time", { lng: "en" }),
        }
    ],
};

export default productConfig;